import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Modal, Button, Dropdown} from 'semantic-ui-react';
import {invoicesTypes} from '../../../../common/dictionaries/classification';
import {Actions} from '../../../../common/actions';
import './confirmation.scss';

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'invoiceTypeSelected': '',
      'transportSelected': '',
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onInvoiceClick = this.onInvoiceClick.bind(this);
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }
  
  onInvoiceClick() {
    const {client, warehouse, agency, items, internalsOrdersList, isInternalsOrdersTab,
      priceEditionReason} = this.props;
    const {invoiceTypeSelected, transportSelected} = this.state;
    const type = isInternalsOrdersTab ? 'internals' : 'manuals';
    const ordersChecked = isInternalsOrdersTab ? _.filter(internalsOrdersList, {'checked': true}) :
      _.filter(items, {'itemSaved': true});
    const ordersCodes = isInternalsOrdersTab ? ordersChecked.map((a) => a.code) : ordersChecked.map((a) => a.partCode);

    const data = {
      client,
      warehouse,
      'type': invoiceTypeSelected,
      'orders': ordersCodes,
      'priceEditionReason': priceEditionReason,
    };

    if (!isInternalsOrdersTab) {
      data.driver = transportSelected;
      data.agency = agency;
    }
    this.props.checkIsInvoiceSaved();
    this.props.saveInvoice(type, data);
    this.onCloseModalClick();
  }

  fetchData() {
    const {isInternalsOrdersTab, client, agency} = this.props;
    this.setState({
      'modalWasOpen': true,
      'invoiceTypeSelected': invoicesTypes[0].value,
      'transportSelected': '',
    });

    if (!isInternalsOrdersTab) {
      this.props.fetchTransports(client, agency);
    }
  }

  getInvoicesTypes() {
    return invoicesTypes.map((item) => {
      return {'text': item.name, 'value': item.value};
    });
  }

  updateInvoiceTypeSelected(value) {
    this.setState({'invoiceTypeSelected': value});
  }

  getTransports() {
    return this.props.listTransports.map((item) => {
      return {'text': item.driverName, 'value': item.driverRuc};
    });
  }

  updateTransportSelected(value) {
    this.setState({'transportSelected': value});
  }

  renderTransportDropdown() {
    const {transportSelected} = this.state;
    const {isInternalsOrdersTab, loadingTransports} = this.props;
    if (isInternalsOrdersTab) {
      return null;
    }
    return (
      <div>
        <h4>Transportista</h4>
        <Dropdown selection
          options={this.getTransports()}
          search
          value={transportSelected}
          disabled={loadingTransports}
          loading={loadingTransports}
          onChange={(e, {value}) => this.updateTransportSelected(value)}
          placeholder='Seleccione un transportista'
          noResultsMessage='Transportista no encontrado'
        />
      </div>
    );
  }

  render() {
    const {modalWasOpen, invoiceTypeSelected, transportSelected} = this.state;
    const {isInternalsOrdersTab, disabled, loading, invoicing} = this.props;
    const transportIsRequired = isInternalsOrdersTab ? false : !transportSelected;

    if (disabled) {
      return (
        <Button
          type='button'
          primary
          className='toyota-primary'
          disabled={true}
          loading={loading}
        >
          Facturar
        </Button>
      );
    }
    
    return (
      <Modal size='tiny' onOpen={() => this.fetchData()}
        className='invoicing-confirmation'
        open={modalWasOpen}
        trigger={
          <Button
            type='button'
            primary
            className='toyota-primary'
            loading={loading}
            disabled={invoicing}
          >
            Facturar
          </Button>
        }>

        <Modal.Header>
          Confirmación
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <p className='message'>Por favor seleccione estos campos obligatorios para proceder</p>
            <div>
              <h4>Tipo Factura</h4>
              <Dropdown selection
                options={this.getInvoicesTypes()}
                searchInput={{'autoFocus': true}}
                value={invoiceTypeSelected}
                onChange={(e, {value}) => this.updateInvoiceTypeSelected(value)}
                placeholder='Seleccione tipo de factura'
              />
            </div>
            {this.renderTransportDropdown()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            disabled={!invoiceTypeSelected || transportIsRequired}
            onClick={this.onInvoiceClick}>
            Facturar
          </Button>
        </Modal.Actions>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'invoicing': state.invoicing.invoicing,
    'internalsOrdersList': state.internalOrder.internalsOrdersList,
    'loadingTransports': state.transport.loading,
    'listTransports': state.transport.list,
  };
};

const {
  fetchTransports,
  saveInvoice,
} = Actions;

export default connect(mapStateToProps, {
  fetchTransports,
  saveInvoice,
})(ConfirmationModal);
